import React, { useState } from 'react';
import { Search } from 'lucide-react';
import Layout from '../components/layout/Layout';
import PhraseCard from '../components/common/PhraseCard';
import { Input } from '../components/ui/input';
import { phraseCategories } from '../data/courseData';
import { cn } from '../lib/utils';

const PhrasesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(phraseCategories[0].id);
  const [searchQuery, setSearchQuery] = useState('');

  const currentCategory = phraseCategories.find(cat => cat.id === selectedCategory);
  
  const filteredPhrases = currentCategory?.phrases.filter(phrase => 
    phrase.en.toLowerCase().includes(searchQuery.toLowerCase()) ||
    phrase.pt.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return (
    <Layout title="Frases Prontas" showBack>
      <div className="px-4 py-6 space-y-6">
        {/* Header */}
        <div className="space-y-1">
          <h1 className="font-display text-2xl font-bold">Frases Prontas</h1>
          <p className="text-muted-foreground">
            Frases úteis organizadas por situação
          </p>
        </div>

        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Buscar frases..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10"
          />
        </div>

        {/* Category Tabs */}
        <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide">
          {phraseCategories.map(category => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={cn(
                'flex items-center gap-2 px-4 py-2.5 rounded-full whitespace-nowrap transition-all',
                selectedCategory === category.id
                  ? 'bg-primary text-primary-foreground shadow-md'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              )}
            >
              <span>{category.icon}</span>
              <span className="text-sm font-medium">{category.name}</span>
            </button>
          ))}
        </div>

        {/* Phrases List */}
        <div className="space-y-3">
          {filteredPhrases.length > 0 ? (
            filteredPhrases.map((phrase, index) => (
              <PhraseCard key={index} phrase={phrase} />
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-muted-foreground">
                Nenhuma frase encontrada
              </p>
            </div>
          )}
        </div>

        {/* Info */}
        <div className="p-4 rounded-xl bg-muted/50">
          <p className="text-sm text-muted-foreground text-center">
            💡 <strong>Dica:</strong> Toque no ícone de som para ouvir a pronúncia
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PhrasesPage;
